module.exports = __webpack_public_path__ + "static/img/momokawa-g.37e79e08.png";